/**
 * DxScheduler event for clicking on appointments
 */
export class AppointmentClickEvent {
    // used to cancel the event
    cancel?: boolean;

    appointmentData: any;
    appointmentElement: any;
    component: any;
    element: HTMLElement;
    event: Event;
}
